import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const Unrefined = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.33398" y="0.5" width="59" height="59" rx="29.5" fill="white" />
      <rect
        x="1.33398"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        stroke="#E2DFDF"
      />
      <circle
        cx="30.4736"
        cy="15"
        r="5.77148"
        fill={productBackground || color}
      />
      <path
        d="M30.8333 38.0171C30.8333 35.4123 32.9449 33.3008 35.5496 33.3008V33.3008C35.8299 33.3008 36.0945 33.1599 36.228 32.9135C36.6975 32.0468 36.9645 31.0544 36.9645 29.9994C36.9645 27.3442 33.1946 22.4733 31.5671 20.4941C31.1834 20.0275 30.4833 20.0275 30.0996 20.4941C28.472 22.4733 24.7021 27.3442 24.7021 29.9994C24.7021 31.0544 24.9692 32.0468 25.4387 32.9135C25.5722 33.1599 25.8368 33.3008 26.117 33.3008V33.3008C28.7218 33.3008 30.8333 35.4123 30.8333 38.0171Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M33.6638 38.9623H31.7772C31.2563 38.9623 30.834 38.54 30.834 38.019V38.019C30.834 35.4143 32.9455 33.3027 35.5503 33.3027H37.4368C37.9578 33.3027 38.3801 33.725 38.3801 34.246V34.246C38.3801 36.8507 36.2685 38.9623 33.6638 38.9623Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M28.0044 38.9623H29.8909C30.4119 38.9623 30.8342 38.54 30.8342 38.019V38.019C30.8342 35.4143 28.7226 33.3027 26.1179 33.3027H24.2313C23.7104 33.3027 23.2881 33.725 23.2881 34.246V34.246C23.2881 36.8507 25.3996 38.9623 28.0044 38.9623Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.6474 29.5878C45.766 29.8498 45.766 30.1502 45.6474 30.4123L44.2797 33.4348C44.2347 33.5342 44.2062 33.6404 44.1956 33.7491L43.8707 37.0499C43.8425 37.3369 43.6917 37.5977 43.4572 37.7654L40.7598 39.6941C40.6703 39.7581 40.592 39.8364 40.528 39.9259L38.5993 42.6233C38.4316 42.8578 38.1708 43.0086 37.8838 43.0368L34.5831 43.3616C34.4745 43.3723 34.3683 43.4007 34.2688 43.4457L31.2463 44.8134C30.9842 44.932 30.6838 44.932 30.4217 44.8134L27.3992 43.4457C27.2997 43.4007 27.1935 43.3723 27.0848 43.3616L23.7842 43.0367C23.4972 43.0085 23.2364 42.8578 23.0687 42.6232L21.1399 39.9258C21.0759 39.8364 20.9976 39.758 20.9081 39.6941L18.2107 37.7653C17.9762 37.5976 17.8254 37.3368 17.7972 37.0498L17.4724 33.7492C17.4617 33.6405 17.4333 33.5343 17.3883 33.4348L16.0205 30.4123C15.902 30.1502 15.902 29.8498 16.0205 29.5878L17.3883 26.5652C17.4333 26.4658 17.4617 26.3596 17.4724 26.2509L17.7972 22.9502C17.8255 22.6632 17.9762 22.4024 18.2108 22.2347L20.9081 20.3059C20.9976 20.2419 21.0759 20.1636 21.1399 20.0741L23.0687 17.3767C23.2364 17.1422 23.4972 16.9914 23.7842 16.9632L27.0848 16.6384C27.1935 16.6277 27.2997 16.5993 27.3992 16.5543L30.4217 15.1866C30.6838 15.068 30.9842 15.068 31.2463 15.1866L34.2687 16.5543C34.3682 16.5993 34.4744 16.6277 34.5831 16.6384L37.8839 16.9633C38.1708 16.9915 38.4317 17.1422 38.5994 17.3768L40.5281 20.0742C40.5921 20.1636 40.6704 20.242 40.7599 20.306L43.4572 22.2347C43.6918 22.4024 43.8425 22.6632 43.8708 22.9502L44.1955 26.2508C44.2062 26.3595 44.2346 26.4657 44.2796 26.5652L45.6474 29.5878Z"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  );
};
